// src/components/panel/DesarrolloRoadmap.js
import React, { useEffect } from 'react';
import { Card, Typography, Progress, Space, Tag, Tooltip } from 'antd';
import { 
    CheckCircleOutlined, 
    RocketOutlined, 
    ExperimentOutlined,
    BarcodeOutlined,
    ShoppingCartOutlined,
    DollarOutlined,
    ShopOutlined,
    FileTextOutlined,
    DatabaseOutlined,
    CreditCardOutlined
} from '@ant-design/icons';
import { useNewFeatures } from '../../hooks/useNewFeatures';

const { Title, Text } = Typography;

const DesarrolloRoadmap = () => {
    const { markAllAsSeen } = useNewFeatures();

    // Mark all features as seen when component mounts (user viewed the tab)
    useEffect(() => {
        markAllAsSeen();
    }, [markAllAsSeen]);
    const roadmapItems = [
        // ===== COMPLETED / IN OPERATION (Left Column) =====
        {
            title: 'Cuentas Corrientes',
            icon: <CreditCardOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Subsistema de Cuenta Abierta - Facturación Abierta',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'Ya Disponible!',
                    date: 'Desde 04/02/2026'
                },
                {
                    name: 'Nuevos filtros (x Número, x Cliente)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 28/01/2026'
                }
            ]
        },
        {
            title: 'Stock',
            icon: <DatabaseOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Nuevo Editor de Stock (Control + Edición + Lógica de packs)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Operaciones de Stock habilitadas en: Facturas - Notas de Crédito - Ordenes de Compra',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                }
            ]
        },
        {
            title: 'Ordenes de Compra',
            icon: <FileTextOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Agregar Productos/Servicios Personalizados',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 31/01/2026'
                },
                {
                    name: 'Adjuntar Archivos a Orden de Compra',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 31/01/2026'
                },
                {
                    name: 'Proveedores SIN CUIT',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 30/01/2026'
                },
                {
                    name: 'Columna IVA en tabla',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Selector "Con Cargas Impositivas" en Nueva Orden de Compra',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Campo Ingresos Brutos en Nueva Orden de Compra',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Campo para Agregar Descuento (Global y Producto x Producto)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación'
                }
            ]
        },
        {
            title: 'Caja',
            icon: <DollarOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Integración dinámica con Ordenes de Compra',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Integración con Cobros Aprobados de Mercado Pago',
                    status: 'implementation',
                    progress: 75,
                    color: '#faad14',
                    tag: 'Fase Implementación'
                }
            ]
        },
        {
            title: 'Facturas',
            icon: <FileTextOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Nuevos filtros (x Número, x Cliente)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 29/01/2026'
                },
                {
                    name: 'Reenviar items de Factura a Carrito con Precio x Volumen y Fracc.',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 28/01/2026'
                },
                {
                    name: 'Factura En Cola automática ante Falla AFIP con Actualizador Manual',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 21/01/2026'
                }
            ]
        },
        {
            title: 'LogIn',
            icon: <CheckCircleOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Aplicación de Token de Acceso para LogIn Automático',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 21/01/2026'
                }
            ]
        },
        {
            title: 'Notas de Crédito',
            icon: <FileTextOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Notas de Crédito Parciales con selección itemizada',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación',
                    date: 'Desde 21/01/2026'
                }
            ]
        },
        {
            title: 'Ventas',
            icon: <ShopOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Habilitar 2 metodos de pago (100% conforme AFIP/ARCA + Analíticas)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación'
                }
            ]
        },
        {
            title: 'Tickets',
            icon: <FileTextOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Corrección CANT. en productos fraccionados (Splitter)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación'
                }
            ]
        },
        {
            title: 'Presupuesto',
            icon: <FileTextOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Presupuesto (Sin sumar analíticas)',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación'
                }
            ]
        },
        {
            title: 'Carrito',
            icon: <ShoppingCartOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Producto Personalizado',
                    status: 'completed',
                    progress: 100,
                    color: '#52c41a',
                    tag: 'En Operación'
                }
            ]
        },
        // ===== PLANNING / IMPLEMENTATION (Right Column) =====
        {
            title: 'Etiquetas',
            icon: <BarcodeOutlined style={{ fontSize: '24px' }} />,
            items: [
                {
                    name: 'Ajuste de Tickets a nuevo formato autoadhesivo',
                    status: 'implementation',
                    progress: 75,
                    color: '#faad14',
                    tag: 'Fase Implementación'
                }
            ]
        }
    ];

    const getStatusIcon = (status) => {
        switch (status) {
            case 'completed':
                return <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '18px' }} />;
            case 'implementation':
                return <RocketOutlined style={{ color: '#faad14', fontSize: '18px' }} />;
            case 'planning':
                return <ExperimentOutlined style={{ color: '#1890ff', fontSize: '18px' }} />;
            default:
                return null;
        }
    };

    // Separate items by status
    const completedItems = roadmapItems.filter(module => 
        module.items.some(item => item.tag === 'Ya Disponible!' || item.tag === 'En Operación' || item.tag === 'Mejora Descriptiva')
    ).map(module => ({
        ...module,
        items: module.items.filter(item => 
            item.tag === 'Ya Disponible!' || item.tag === 'En Operación' || item.tag === 'Mejora Descriptiva'
        )
    })).filter(module => module.items.length > 0);

    const inDevelopmentItems = roadmapItems.filter(module => 
        module.items.some(item => item.tag === 'Fase Planificación' || item.tag === 'Fase Implementación')
    ).map(module => ({
        ...module,
        items: module.items.filter(item => 
            item.tag === 'Fase Planificación' || item.tag === 'Fase Implementación'
        )
    })).filter(module => module.items.length > 0);

    const renderModuleCard = (module, index) => (
        <Card
            key={index}
            size="small"
            style={{ 
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                background: '#ffffff'
            }}
        >
            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ 
                    background: '#f0f5ff', 
                    padding: '8px', 
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {module.icon}
                </div>
                <Title level={5} style={{ margin: 0, color: '#1890ff' }}>
                    {module.title}
                </Title>
            </div>
            
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                {module.items.map((item, itemIndex) => (
                    <div key={itemIndex}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            marginBottom: '8px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                                {getStatusIcon(item.status)}
                                <Text strong style={{ fontSize: '14px' }}>{item.name}</Text>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                                <Tag 
                                    color={item.color}
                                    style={{ 
                                        marginLeft: '8px',
                                        fontWeight: 'bold',
                                        borderRadius: '4px',
                                        marginBottom: 0
                                    }}
                                >
                                    {item.tag}
                                </Tag>
                                {item.date && (
                                    <Text type="secondary" style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                        {item.date}
                                    </Text>
                                )}
                            </div>
                        </div>
                        
                        <Tooltip title={`${item.progress}% completado`}>
                            <Progress 
                                percent={item.progress} 
                                strokeColor={item.color}
                                trailColor="#f0f0f0"
                                size="small"
                                showInfo={false}
                                strokeLinecap="round"
                                style={{ marginBottom: 0 }}
                            />
                        </Tooltip>
                    </div>
                ))}
            </Space>
        </Card>
    );

    return (
        <Card 
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <RocketOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
                    <Title level={4} style={{ margin: 0 }}>Hoja de Ruta - Próximas Funcionalidades</Title>
                </div>
            }
            bordered={false}
            style={{ 
                height: '100%',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}
        >
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                {/* Left Column: Completed / In Operation */}
                <div>
                    <div style={{ 
                        marginBottom: '16px', 
                        padding: '12px',
                        background: 'rgba(82, 196, 26, 0.1)',
                        borderRadius: '8px',
                        borderLeft: '4px solid #52c41a'
                    }}>
                        <Title level={5} style={{ margin: 0, color: '#52c41a' }}>
                            ✅ Ya Disponible! / En Operación
                        </Title>
                    </div>
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        {completedItems.map((module, index) => renderModuleCard(module, index))}
                    </Space>
                </div>

                {/* Right Column: Planning / Implementation */}
                <div>
                    <div style={{ 
                        marginBottom: '16px', 
                        padding: '12px',
                        background: 'rgba(24, 144, 255, 0.1)',
                        borderRadius: '8px',
                        borderLeft: '4px solid #1890ff'
                    }}>
                        <Title level={5} style={{ margin: 0, color: '#1890ff' }}>
                            🚧 Fase Planificación / Fase Implementación
                        </Title>
                    </div>
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        {inDevelopmentItems.map((module, index) => renderModuleCard(module, index))}
                    </Space>
                </div>
            </div>
        </Card>
    );
};

export default DesarrolloRoadmap;
